export enum DashboardUIMode {
  VIEW = 'view',
  MANAGE = 'manage',
}
